import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ServerPath } from '../../shared/constants';
import YouTube from 'react-youtube';
import axios from 'axios';
import AOS from "aos";
import "aos/dist/aos.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import "swiper/css";

const Home = ({assets})  => {
  
  const navigate = useNavigate();

  const [mdticoin, setMDTI] = useState({});
  const [krw_rate, setKrwRate] = useState(1300);
  const [mdti_rate, setMDTIRate] = useState(0);
  const [board_data, setBoard] = useState([]);
  const { t } = useTranslation();
    
  const onInit = useCallback(async () => {
    const token = localStorage.getItem('userToken');
    if (!token) return;
  
    try {
      const krw_rate_result = await axios.get('https://api.bithumb.com/public/ticker/ALL');
      const newKrwRate = krw_rate_result.data.data['USDT'].opening_price;
      setKrwRate(newKrwRate);
    } catch (err) {
      console.error('KRW 환율 데이터를 가져오는 중 오류 발생:', err);
    }

    try {
      const mdti_rate_result = await axios.get('https://api.vindax.com/api/v1/returnTicker?symbol=MDTIUSDT');
      setMDTIRate(Number(mdti_rate_result.data.MDTI_USDT.last));
    } catch (err) {
      console.log(err);
    }

    const boardData = { page: 0, unit: 3 };
  
    try {
      const newsResult = await axios.post(
        `${ServerPath}/news/list`,
        boardData,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setBoard(newsResult.data.select);
    } catch (err) {
      console.error('뉴스 데이터를 가져오는 중 오류 발생:', err);
    }
  }, []); 
  
  useEffect(() => {
    AOS.init();  // AOS 초기화
    onInit();
    if (assets) {
      const MDTICoin = assets.find(n => n.token_type === 'MDTI');
      if (MDTICoin && mdti_rate !== MDTICoin) {  // 상태가 변경된 경우에만 업데이트
        setMDTI(MDTICoin);
      }
    }
  }, [assets]);

  const getTicker = async () => {
    try {
      const mdti_rate_result = await axios.get('https://api.vindax.com/api/v1/returnTicker?symbol=MDTIUSDT');
      console.log(mdti_rate_result);
      if (mdti_rate !== Number(mdti_rate_result.data.MDTI_USDT.last))
        setMDTIRate(Number(mdti_rate_result.data.MDTI_USDT.last));
    } catch (err) {
      console.log(err);
    }
  }
  function getCoinAmount(value) {
    return Number(value).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');;
  }

  const linkTo = (link) => {
    navigate('/' + link);
  }
  
  const purchase_price = 500;
  
  return  (
    <section>
      <div>
        <div className="mstep1">
        <Swiper 
          spaceBetween={30}
          centeredSlides={true}
          autoplay={{
          delay: 6000,
          disableOnInteraction: false,
          }}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"
        >
              <SwiperSlide className="swiper-slide"><YouTube
                //videoId : https://www.youtube.com/watch?v={videoId} 유튜브 링크의 끝부분에 있는 고유한 아이디
                  videoId={"MBw1CJeX_HA"}
                //opts(옵션들): 플레이어의 크기나 다양한 플레이어 매개 변수를 사용할 수 있음.
                //밑에서 더 설명하겠습니다.
                  opts={{
                    width: "100%",
                    height: "450",
                    playerVars: {
                      autoplay: 1, //자동재생 O
                      rel: 0, //관련 동영상 표시하지 않음 (근데 별로 쓸모 없는듯..)
                      modestbranding: 1, // 컨트롤 바에 youtube 로고를 표시하지 않음
                    },
                  }}
                  //이벤트 리스너 
                  onEnd={(e)=>{e.target.stopVideo(0);}}      
                /></SwiperSlide>
        </Swiper>
        </div>


        <div className="mstep2" onClick={()=>linkTo('details')} >
            <div className="ms2_card" data-aos="fade-up">
              <div className="ms2_txt">MY COIN</div> 
              <div className="ms2_card_txt">
                <div className="c_txt1">보유 MDTI 총량</div>
                <div className="c_txt2">{Object.keys(mdticoin).length !== 0? getCoinAmount(mdticoin.total_amount): 0.00} MDTI</div>
                <div className="c_txt3">(구매금액 : {Object.keys(mdticoin).length === 0 || krw_rate === 0 || mdti_rate ===0 || mdticoin.total_amount === 0 || isNaN(mdticoin.total_amount * mdti_rate * krw_rate) ?"0":Math.floor(Number(mdticoin.total_amount * purchase_price)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원)</div>
                <div className="c_txt4">= {Object.keys(mdticoin).length === 0 || krw_rate === 0 || mdti_rate ===0 || mdticoin.total_amount === 0 || isNaN(mdticoin.total_amount * mdti_rate * krw_rate) ?"0":Math.floor(Number(mdticoin.total_amount * mdti_rate * krw_rate)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} KRW
                  <span>+{Object.keys(mdticoin).length === 0 || krw_rate === 0 || mdti_rate ===0 || mdticoin.total_amount === 0 || isNaN(mdti_rate * krw_rate) ?"0":getCoinAmount(((mdti_rate * krw_rate) - purchase_price)/(purchase_price/100))}%</span></div>
              </div>
              <div className="ms2_txt2">1 MDTI = { krw_rate === 0 || mdti_rate ===0 || mdticoin.total_amount === 0 || isNaN(mdti_rate * krw_rate) ?"0":getCoinAmount(mdti_rate * krw_rate)} {t('home.won')}</div>
              <img src="images/m_card_bg2.png" alt="" />
            </div>		
          </div>
        <div className="mstep3">
          <div className="mtitle"><b>HOT Issue</b><div href="#" className="bt_more" onClick={() =>linkTo('news')} >MORE +</div></div>
          
          { board_data.map((item, i) => (
              <div key={i} className="mlist"  data-aos="fade-up" onClick={() =>linkTo('board/news/' + item.id)} >
              <div className="mlist_thum"> <img src={item.image_kor} alt={"image" + i}/></div>
              <div className="mlist_line">
                <p>{item.title_kor}</p>
                <span>{item.content_kor}</span>
              </div>
            </div>
              ))}
        </div>
      </div>
      
    </section>
    
  );
};

const mapStateToProps = ({ authUser }) => {
  const { currentUser, assets } = authUser;
  return { currentUser, assets}
};

export default connect(mapStateToProps, null)(Home);

